export const CancellationInitialValues = {
  createdAt: new Date(),
  cancellationReason: '',
  observations: '',
  userId: '',
  bondInsuranceId: '',
  policyFiles: [],
  fieldName: '',
  notificationEmails: [''],
  relatedPoliciesIds: []
};
